import React from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
function ModalBody(_ref) {
  var {
    className,
    style,
    children,
    'data-testid': dataTestId
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: classNames('modal-body', className),
    "data-testid": dataTestId,
    style: style,
    children: children
  });
}
export default ModalBody;
//# sourceMappingURL=ModalBody.js.map